import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import { useParams } from 'react-router-dom'
import Member from '../models/Member'
import Palette from '../Palette'
import Swal from 'sweetalert2'
import parse from 'html-react-parser'
import moment from 'moment'
import Spinner from 'react-bootstrap/Spinner'
import { AiOutlineLink, FaDownload } from 'react-icons/all'
import profile from '../assets/default_user.png'
import TextTranslator from '../util/TextTranslator'
import Membership from '../models/Membership'
import MemberBadge from '../models/MemberBadge'
import Badge from '../models/Badge'

export default function ResultDetailPage(props) {
    const { id, hpi_id } = useParams()
    const [memberBadges, setMemberBadges] = useState([])

    let member = new Member()
    const membership = new Membership()
    // http://localhost:3000/result/4649?ref=scan
    const scanRef = new URLSearchParams(window.location.search).get('ref')
    const [currentMember, setCurrentMember] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getMemberData()
    }, [])

    const getMemberData = async () => {
        setIsLoading(true)
        try {
            console.log('PARAMU', id, hpi_id)
            let memberData

            if (id) {
                memberData = await member.getMemberById(id)
                console.log('MEMBER DATA:', memberData)
                setCurrentMember(memberData)

                try {
                    const memberBadge = new MemberBadge()
                    const badge = new Badge()

                    console.log('Fetching badges for member ID:', id)
                    const badgesResponse = await memberBadge.getByMemberID(id)
                    console.log('Raw badges response:', badgesResponse)

                    const badgeAssignments = Array.isArray(badgesResponse)
                        ? badgesResponse
                        : badgesResponse?.data || []

                    console.log('Badge assignments:', badgeAssignments)

                    if (badgeAssignments.length > 0) {
                        console.log('Processing badge assignments...')

                        const badgeDetails = await Promise.all(
                            badgeAssignments.map(async (assignment) => {
                                try {
                                    console.log(`Fetching badge ID ${assignment.badge_id}`)
                                    const badgeDetail = await badge.getById(assignment.badge_id)
                                    console.log(
                                        `Badge ${assignment.badge_id} details:`,
                                        badgeDetail,
                                    )

                                    return {
                                        id: badgeDetail.id || assignment.badge_id,
                                        name: badgeDetail.label || `Badge ${assignment.badge_id}`,
                                        image_url: badgeDetail.icon_url,
                                        description: badgeDetail.description,
                                        date_start: assignment.date_start,
                                        date_end: assignment.date_end,
                                    }
                                } catch (e) {
                                    console.error(`Error loading badge ${assignment.badge_id}:`, e)
                                    return null
                                }
                            }),
                        )

                        const validBadges = badgeDetails.filter((b) => b !== null)

                        const currentDate = new Date()
                        const activeBadges = validBadges.filter((badge) => {
                            if (!badge.date_end) return true
                            const endDate = new Date(badge.date_end)
                            return endDate >= currentDate
                        })

                        console.log('Active badges:', activeBadges)
                        setMemberBadges(activeBadges)
                    } else {
                        console.log('No badge assignments found')
                        setMemberBadges([])
                    }
                } catch (badgeError) {
                    console.error('Error fetching badges:', badgeError)
                    setMemberBadges([])
                }
            } else if (hpi_id) {
                memberData = await member.getMemberByHPIId(hpi_id)
                console.log('MEMBER DATA:', memberData)
                setCurrentMember(memberData)

                if (memberData.id) {
                    try {
                        const memberBadge = new MemberBadge()
                        const badge = new Badge()

                        console.log('Fetching badges for member ID:', memberData.id)
                        const badgesResponse = await memberBadge.getByMemberID(memberData.id)
                        console.log('Raw badges response:', badgesResponse)

                        const badgeAssignments = Array.isArray(badgesResponse)
                            ? badgesResponse
                            : badgesResponse?.data || []

                        if (badgeAssignments.length > 0) {
                            const badgeDetails = await Promise.all(
                                badgeAssignments.map(async (assignment) => {
                                    try {
                                        const badgeDetail = await badge.getById(assignment.badge_id)
                                        return {
                                            id: badgeDetail.id || assignment.badge_id,
                                            name:
                                                badgeDetail.label || `Badge ${assignment.badge_id}`,
                                            image_url: badgeDetail.icon_url,
                                            date_start: assignment.date_start,
                                            date_end: assignment.date_end,
                                        }
                                    } catch (e) {
                                        console.error(
                                            `Error loading badge ${assignment.badge_id}:`,
                                            e,
                                        )
                                        return null
                                    }
                                }),
                            )

                            const validBadges = badgeDetails.filter((b) => b !== null)

                            const currentDate = new Date()
                            const activeBadges = validBadges.filter((badge) => {
                                if (!badge.date_end) return true
                                const endDate = new Date(badge.date_end)
                                return endDate >= currentDate
                            })

                            setMemberBadges(activeBadges)
                        } else {
                            setMemberBadges([])
                        }
                    } catch (badgeError) {
                        console.error('Error fetching badges:', badgeError)
                        setMemberBadges([])
                    }
                }
            } else {
                setCurrentMember(null)
                console.log('Member data not found!')
            }

            // Member verification for scan reference
            if (scanRef === 'scan' && memberData && (memberData.hpi_id || memberData.id)) {
                let message = `Pemilik akun ini adalah Anggota Profesional HPI aktif.
                               <br /> <i>This account's owner is an HPI Professional Member in good standing.</i>`
                let iconMessage = 'success'

                if (!memberData.active || !memberData.status) {
                    message = `Akun ini sudah tidak aktif.
                                <br /> <i>This account is no longer active.</i>`
                    iconMessage = 'warning'
                }

                if (!memberData?.current_membership) {
                    message = `Akun ini sudah tidak aktif.
                                <br /> <i>This account is no longer active.</i>`
                    iconMessage = 'warning'
                }

                if (moment(memberData?.current_membership?.valid_until).isBefore(moment())) {
                    message = `Akun ini sudah tidak aktif.
                                <br /> <i>This account is no longer active.</i>`
                    iconMessage = 'warning'
                }

                Swal.fire({
                    html: message,
                    icon: iconMessage,
                    confirmButtonText: 'OK',
                })
            }
        } catch (e) {
            if (e?.http_code === 404 && scanRef === 'scan') {
                Swal.fire({
                    html: `Akun ini tidak terdaftar di dalam sistem kami.
                            <br /> <i>This account does not exist.</i>`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                })
            }
            console.error(e)
            setMemberBadges([])
        } finally {
            setIsLoading(false)
        }
    }

    const result = {
        id: 'HPI-01-04-0073',
        main_photo_url: profile,
        name: 'Larry McLovin',
        profession: ['Translator', 'Interpreter'],
        description:
            'He has suspenders, a desk, a TV show, different color lights behind him, and a marquee at the bottom of the screen saying what was just said even though you just heard him.',
        specialization:
            'Art - Architecture, Automotive, Agriculture, Banking, Books-Fiction, Books-Non-Fiction, Business and Commerce, Culture, Education, Electrical - Electronics, Engineering, Environment, Fashion - Clothing, Film - TV, Finance, Food Industry, Forestry, Games and Entertainment, General, Geography, Government - Politics, Hospitality Industry, Law Enforcement, Legal - Contracts, Legal - General, Legal - Law, Literature - Poetry, Management, Marketing, Military - Defense, Mining-Mineral and Coal, Music, Oil and Gas, Religion, Science, Soc',
        languages: ['English', 'Indonesian'],
        services:
            'Translation, Editing, Proofreading, Localization, Subtitling, Transcription, Consecutive Interpreting, Simultaneous Interpreting',
        tools: 'Trados Studio, Wordfast Classic, OmegaT, Other',
        education:
            'Bachelor Degree, Management Faculty, Management Banking, ABFI Institute (STIE Perbanas)',
        full_time: true,
        occupation: 'Freelance',
        experience: 'Translator since June 1994',
        member: [
            'ProZ: http://www.proz.com/profile/1176796 ',
            'TranslatorsCafe: http://RURYDA.TranslatorsCafe.com',
        ],
        currencies: ['IDR', 'USD', 'EUR', 'GBP'],
        payment: ['Domestic bank transfer, International wire transfer', 'Paypal', 'Other'],
    }

    return (
        <>
            <Container
                style={{
                    backgroundColor: 'white',
                    borderRadius: 10,
                    color: '#363636',
                    marginTop: 30,
                }}
            >
                <Row>
                    <Col md={4} className="shadow-sm pb-2 mr-3 h-100">
                        <div className="d-block text-center">
                            <img
                                src={
                                    currentMember?.profile_picture_url
                                        ? currentMember.profile_picture_url
                                        : profile
                                }
                                style={{
                                    maxWidth: '100%',
                                    objectFit: 'contain',
                                }}
                                alt={currentMember?.full_name}
                            />
                            <div className="my-2">
                                <b>{currentMember?.hpi_id}</b>
                            </div>

                            <div className="my-2">
                                Member since {moment(currentMember?.approval_date).format('YYYY')}
                            </div>

                            {currentMember ? (
                                <a href={`mailto:${currentMember.email}`}>
                                    <Button
                                        style={{
                                            fontFamily: 'Signika',
                                            fontWeight: 'bold',
                                            paddingTop: 10,
                                            paddingBottom: 10,
                                            width: '100%',
                                            backgroundColor: Palette.PRIMARY,
                                            borderColor: Palette.PRIMARY,
                                            borderRadius: '20px',
                                        }}
                                        className="my-2"
                                    >
                                        SEND A MESSAGE
                                    </Button>
                                </a>
                            ) : (
                                ''
                            )}
                        </div>
                    </Col>
                    <Col className="shadow-sm d-block">
                        {isLoading ? (
                            <Spinner
                                style={{
                                    width: '4rem',
                                    height: '4rem',
                                    marginLeft: '47%',
                                    marginTop: '5%',
                                    marginBottom: '5%',
                                }}
                                animation="border"
                                variant="danger"
                            />
                        ) : currentMember ? (
                            <>
                                <h1
                                    style={{
                                        fontFamily: 'Roboto',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {currentMember.full_name}
                                </h1>

                                <div className="d-flex mb-5 flex-wrap" style={{ gap: '8px' }}>
                                    {memberBadges.length > 0 ? (
                                        memberBadges.map((badge) =>
                                            badge.description ? (
                                                <OverlayTrigger
                                                    key={`badge-${badge.id}`}
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip id={`tooltip-badge-${badge.id}`}>
                                                            {badge.name} - ({badge.description})
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div
                                                        className="badge-pill"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '4px 12px',
                                                            backgroundColor: '#D3D3D3',
                                                            borderRadius: '16px',
                                                            //border: '1px solid #224AD7',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {badge.image_url && (
                                                            <img
                                                                src={badge.image_url}
                                                                alt={badge.name}
                                                                style={{
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    //marginRight: '6px',
                                                                }}
                                                            />
                                                        )}
                                                        {/* <span style={{ color: '#224AD7' }}>
                                                            {badge.name}
                                                        </span> */}
                                                    </div>
                                                </OverlayTrigger>
                                            ) : (
                                                // <div
                                                //     key={`badge-${badge.id}`}
                                                //     className="badge-pill"
                                                //     style={{
                                                //         display: 'flex',
                                                //         alignItems: 'center',
                                                //         padding: '4px 12px',
                                                //         backgroundColor: '#f0f8ff',
                                                //         borderRadius: '20px',
                                                //         border: '1px solid #224AD7',
                                                //         cursor: 'pointer',
                                                //     }}
                                                // >
                                                //     {badge.image_url && (
                                                //         <img
                                                //             src={badge.image_url}
                                                //             alt={badge.name}
                                                //             style={{
                                                //                 width: '16px',
                                                //                 height: '16px',
                                                //                 marginRight: '6px',
                                                //             }}
                                                //         />
                                                //     )}
                                                //     <span style={{ color: '#224AD7' }}>
                                                //         {badge.name}
                                                //     </span>
                                                // </div>
                                                <OverlayTrigger
                                                    key={`badge-${badge.id}`}
                                                    placement="bottom"
                                                    overlay={
                                                        <Tooltip id={`tooltip-badge-${badge.id}`}>
                                                            {badge.name}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div
                                                        className="badge-pill"
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '4px 12px',
                                                            backgroundColor: '#D3D3D3',
                                                            borderRadius: '16px',
                                                            //border: '1px solid #224AD7',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {badge.image_url && (
                                                            <img
                                                                src={badge.image_url}
                                                                alt={badge.name}
                                                                style={{
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    //marginRight: '6px',
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </OverlayTrigger>
                                            ),
                                        )
                                    ) : (
                                        <div className="badge-pill">
                                            {currentMember &&
                                                TextTranslator.getProfesi(currentMember.profession)}
                                        </div>
                                    )}
                                </div>

                                <div className="my-3">
                                    <div>
                                        <b>Resume</b>
                                    </div>
                                    {currentMember.resume ? parse(currentMember.resume) : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Specializations</b>
                                    </div>
                                    {currentMember?.specializations
                                        ? currentMember.specializations.length > 0
                                            ? currentMember.specializations.map((obj, idx) => {
                                                  return (
                                                      <>
                                                          {obj.specialization}
                                                          {idx <
                                                          currentMember.specializations.length - 1
                                                              ? ', '
                                                              : ''}
                                                      </>
                                                  )
                                              })
                                            : '-'
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Language Pairs</b>
                                    </div>
                                    {currentMember.languages
                                        ? currentMember.languages.map((lang) => {
                                              return (
                                                  <div>
                                                      {lang.language_from} - {lang.language_to}{' '}
                                                      {lang.certification === 'NONE' ||
                                                      lang.certification === null
                                                          ? ''
                                                          : '(HPI Certification: ' +
                                                            lang.certification +
                                                            ')'}
                                                      <br />
                                                  </div>
                                              )
                                          })
                                        : ''}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Certification</b>
                                    </div>
                                    {currentMember?.member_certificates
                                        ? currentMember?.member_certificates?.length > 0
                                            ? currentMember?.member_certificates?.map((v) => {
                                                  return (
                                                      <>
                                                          <div>
                                                              <span className="mr-3">
                                                                  {' '}
                                                                  {v?.certification_type}
                                                              </span>
                                                              <span className="badge badge-primary mr-3">
                                                                  {v?.certification_number}
                                                              </span>
                                                              <span></span>
                                                              {v?.valid_until == null ? null : (
                                                                  <p
                                                                      className="text-secondary"
                                                                      style={{ fontSize: '.7em' }}
                                                                  >
                                                                      Valid Until :{' '}
                                                                      {moment(
                                                                          v?.valid_until,
                                                                      ).format('DD MMM YYYY')}
                                                                  </p>
                                                              )}
                                                          </div>
                                                      </>
                                                  )
                                              })
                                            : '-'
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Services</b>
                                    </div>
                                    {currentMember.service_offered
                                        ? parse(currentMember.service_offered)
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Software</b>
                                    </div>
                                    {currentMember.software ? currentMember.software : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Education</b>
                                    </div>
                                    {currentMember.education ? parse(currentMember.education) : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Availability</b>
                                    </div>
                                    {currentMember.availability
                                        ? TextTranslator.getKetersediaan(currentMember.availability)
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Work Status</b>
                                    </div>
                                    {currentMember.occupation
                                        ? TextTranslator.getStatusPekerjaan(
                                              currentMember.occupation,
                                          )
                                        : '-'}
                                </div>
                                <div
                                    className="my-3"
                                    style={{
                                        whiteSpace: 'pre-line',
                                    }}
                                >
                                    <div className="mb-1">
                                        <b>Work Experience</b>
                                    </div>
                                    {currentMember.profession === 'Both' ||
                                    currentMember.profession === 'Interpreter' ||
                                    currentMember.profession === 'both' ||
                                    currentMember.profession === 'interpreter'
                                        ? currentMember.translator_since
                                            ? `Interpreter since ${currentMember.interpreter_since}`
                                            : '-'
                                        : ''}
                                    {currentMember.profession === 'Both' ||
                                    currentMember.profession === 'Translator' ||
                                    currentMember.profession === 'both' ||
                                    currentMember.profession === 'translator'
                                        ? currentMember.translator_since
                                            ? `${
                                                  currentMember.profession === 'Both' ||
                                                  currentMember.profession === 'both'
                                                      ? '\n'
                                                      : ''
                                              }Translator since ${currentMember.translator_since}`
                                            : '-'
                                        : ''}
                                </div>
                                {/*<div className="my-3">*/}
                                {/*    <div className="mb-1">*/}
                                {/*        <b>Member of </b>*/}
                                {/*    </div>*/}
                                {/*    {result.member.map((mem) => {*/}
                                {/*        return <div className="px-2 mr-1">{mem}</div>*/}
                                {/*    })}*/}
                                {/*</div>*/}
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Preferred Currency</b>
                                    </div>
                                    {currentMember.preferred_currency
                                        ? currentMember.preferred_currency
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Payment Method</b>
                                    </div>
                                    {currentMember.payment_method
                                        ? currentMember.payment_method
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>Member of</b>
                                    </div>
                                    {Array.isArray(currentMember.memberscol) &&
                                    currentMember.memberscol.length > 0
                                        ? currentMember.memberscol.map((obj, idx) => {
                                              return (
                                                  <>
                                                      <div
                                                          style={{
                                                              backgroundColor: Palette.PRIMARY,
                                                              borderRadius: 5,
                                                              display: 'inline-block',
                                                              minWidth: 100,
                                                              color: 'white',
                                                              textAlign: 'center',
                                                              paddingTop: 3,
                                                              paddingBottom: 3,
                                                              paddingRight: 5,
                                                              paddingLeft: 5,
                                                          }}
                                                      >
                                                          <div
                                                              style={{
                                                                  display: 'flex',
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                              }}
                                                          >
                                                              <div
                                                                  style={{
                                                                      flex: 1,
                                                                  }}
                                                              >
                                                                  {obj.organization}
                                                              </div>

                                                              <div
                                                                  style={{
                                                                      alignItems: 'center',
                                                                      justifyContent: 'center',
                                                                  }}
                                                              >
                                                                  <a
                                                                      href={obj.url}
                                                                      target={'_blank'}
                                                                  >
                                                                      <AiOutlineLink
                                                                          style={{
                                                                              color: 'white',
                                                                              marginRight: 5,
                                                                              marginLeft: 10,
                                                                          }}
                                                                      />
                                                                  </a>
                                                              </div>
                                                          </div>
                                                      </div>

                                                      {/*<a href={obj.location}>*/}
                                                      {/*    <Button*/}
                                                      {/*        size={"sm"}*/}
                                                      {/*        style={{*/}
                                                      {/*            */}
                                                      {/*            borderColor: Palette.PRIMARY,*/}
                                                      {/*        }}*/}
                                                      {/*    >*/}
                                                      {/*        */}
                                                      {/*    </Button>*/}
                                                      {/*</a>*/}
                                                  </>
                                              )
                                          })
                                        : '-'}
                                </div>
                                <div className="my-3">
                                    <div className="mb-1">
                                        <b>File</b>
                                    </div>
                                    {Array.isArray(currentMember.files) &&
                                    currentMember.files.length > 0
                                        ? currentMember.files.map((obj, idx) => {
                                              return (
                                                  <>
                                                      <div
                                                          style={{
                                                              backgroundColor: Palette.PRIMARY,
                                                              borderRadius: 5,
                                                              display: 'inline-block',
                                                              minWidth: 100,
                                                              color: 'white',
                                                              textAlign: 'center',
                                                              paddingTop: 3,
                                                              paddingBottom: 3,
                                                              paddingRight: 5,
                                                              paddingLeft: 5,
                                                          }}
                                                      >
                                                          <div
                                                              style={{
                                                                  display: 'flex',
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                              }}
                                                          >
                                                              <div
                                                                  style={{
                                                                      flex: 1,
                                                                  }}
                                                              >
                                                                  {obj.name}
                                                              </div>

                                                              <div
                                                                  style={{
                                                                      alignItems: 'center',
                                                                      justifyContent: 'center',
                                                                  }}
                                                              >
                                                                  <a href={obj.location}>
                                                                      <FaDownload
                                                                          style={{
                                                                              color: 'white',
                                                                              marginRight: 5,
                                                                              marginLeft: 10,
                                                                          }}
                                                                      />
                                                                  </a>
                                                              </div>
                                                          </div>
                                                      </div>

                                                      {/*<a href={obj.location}>*/}
                                                      {/*    <Button*/}
                                                      {/*        size={"sm"}*/}
                                                      {/*        style={{*/}
                                                      {/*            */}
                                                      {/*            borderColor: Palette.PRIMARY,*/}
                                                      {/*        }}*/}
                                                      {/*    >*/}
                                                      {/*        */}
                                                      {/*    </Button>*/}
                                                      {/*</a>*/}
                                                  </>
                                              )
                                          })
                                        : '-'}
                                </div>
                            </>
                        ) : (
                            <div
                                style={{
                                    width: '100%',
                                    textAlign: 'center',
                                    marginTop: 10,
                                    marginBottom: 20,
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        color: 'grey',
                                        fontSize: '1.5em',
                                    }}
                                >
                                    No Search Result
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        </>
    )
}
